import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const DIALOG_CONTENT_CLASS_NAME = tv({
  base: clsx("fixed flex flex-col h-screen"),
  variants: {
    bgColor: {
      gray: "bg-grayScale-100",
      white: "bg-base-0",
    },
    isOpen: {
      true: "",
      false: "",
    },
    direction: {
      left: "left-0",
      right: "right-0",
    },
    shadow: {
      true: "shadow-high",
      false: "",
    },
    absoluteTop: {
      true: "top-0 z-drawer",
      false: "",
    },
    widthType: {
      "fixed-sm": "w-[272px]",
      "fixed-md": "w-[586px]",
      flex: "w-fit",
    },
    isInDialog: {
      true: "z-modal",
      false: "",
    },
  },
  compoundVariants: [
    {
      isOpen: true,
      direction: "left",
      className: "animate-[slideInLeft_200ms_ease-in-out]",
    },
    {
      isOpen: false,
      direction: "left",
      className: "animate-[slideOutLeft_200ms_ease-in-out]",
    },
    {
      isOpen: true,
      direction: "right",
      className: "animate-[slideInRight_200ms_ease-in-out]",
    },
    {
      isOpen: false,
      direction: "right",
      className: "animate-[slideOutRight_200ms_ease-in-out]",
    },
  ],
  defaultVariants: {
    bgColor: "white",
  },
});
